// eslint-disable-next-line
export const errorMapper = (message: string, e: any) => {
  if (e?.response?.data?.message.includes('already exists')) {
    return 'Пользователь с таким логином уже существует'
  }
  switch (e?.response?.data?.message) {
    case 'name must be unique':
      return 'Имя должно быть уникальным'
    case 'phone must be unique':
      return 'телефон должен быть уникальным'
    case 'email must be unique':
      return 'email должен быть уникальным'
    case 'Not found task for this user pls check filter':
      return 'Нет текущих задач'
    case 'New base not found in this crm':
      return 'Нет новых баз данных'
    case 'Filter not found':
      return 'Нет фильтров для менеджера'
    case 'Please billing update':
      return 'Срок подписки на CRM окончен'
    case 'Invalid url':
      return 'Не верная ссылка на CRM'
    case 'Crm already already added':
      return 'CRM с такой ссылкой уже есть'
    default:
      return message
  }
}
